import React, { useState, useCallback, useRef } from 'react';
import Pagination from 'react-js-pagination';

const getTop = element => {
  let top = 0;
  if (element.offsetParent) {
    do {
      top += element.offsetTop;
      element = element.offsetParent;
    } while (element);
  }
  return top >= 0 ? top : 0;
}

export default ({ hideFirstLastPages = false, perPage = 10, total = 0, children, ...props }) => {
  const ref = useRef(null);
  const [ totalRows, setTotal ] = useState(total);
  const [ currentPage, setPage ] = useState(null)
  const [ version, setVersion ] = useState(0)

  const updateTotal = useCallback(total => {
    setTotal(total)
    // version used for update busting
    setVersion(version => version + 1);
  }, [ setTotal, setVersion ])

  const pagination = {
    perPage: (!perPage || perPage <= 0) ? null : perPage,
    currentPage,
    totalRows,
    version,
    setPage,
    setTotal: updateTotal,
  };

  const handleChange = page => {
    if (ref && ref.current) {
      // scroll up to top of element (not down)
      const top = getTop(ref.current) - 50;
      if (window.scrollY > top) {
        window.scrollTo({ top, behavior: 'smooth' })
      }
    }

    setPage(page)
  }

  return <>
    <span ref={ref}></span>
    { React.cloneElement(children, { ...pagination, ...props })}
    {pagination.perPage != null && pagination.totalRows > pagination.perPage && <Pagination
      activePage={pagination.currentPage}
      itemsCountPerPage={pagination.perPage}
      totalItemsCount={pagination.totalRows}
      pageRangeDisplayed={-1}
      prevPageText="&nbsp;&nbsp;&nbsp;⟨&nbsp;&nbsp;&nbsp;"
      nextPageText="&nbsp;&nbsp;&nbsp;⟩&nbsp;&nbsp;&nbsp;"
      hideFirstLastPages={hideFirstLastPages}
      onChange={handleChange}
      itemClass="page-item"
      linkClass="page-link"
    />}
  </>
}
